<template>
    <!-- 告警设置 -->
    <content-view v-if="$utils.renderWhen(this,'setSmartWrist')">
        <div class="integral-set">
            <a-card title="儿童告警">
                <a-row class="pb16 pt8">
                    <a-col :span="colOne">
                        <div class="title-text pb8">儿童出场告警</div>
                        儿童出场后超出设定的时间或距离条件进行告警
                    </a-col>
                    <a-col :span="colTwo" class="text-primary pt32">
                        时间：{{childwarns.departureIntervalTime || '--'}}分钟 距离：{{childwarns.departureIntervalGap || '--'}}米
                    </a-col>
                    <a-col v-if="flag" :span="colThree" class="pt16" >
                        <a-popconfirm
                            v-if="getBtnByAuth('setSmartWristState')"
                            :title="'确定'+['启用','禁用'][childwarns.status]+'吗?'"
                            @confirm="warnsetState(childwarns.id,childwarns.status)"
                            >
                            <a-button >{{['启用','禁用'][childwarns.status]}}</a-button>
                        </a-popconfirm>
                        <a-button @click="openChild(childwarns.id)" v-if="getBtnByAuth('setSmartWristEdit')">编辑</a-button>
                    </a-col>
                </a-row>
            </a-card>
            <div class="mt24"></div>
            <a-card title="进出场告警">
                <a-row class="line-bodder pb16 pt8">
                    <a-col :span="colOne">
                        <div class="title-text pb8">非法设备进场告警</div>
                        当日未绑定激活的设备或禁用设备进场系统进行告警
                    </a-col>
                    <a-col :span="colTwo" class="text-primary pt32">

                    </a-col>
                    <a-col v-if="flag" :span="colThree" class="pt16">
                        <a-popconfirm
                            v-if="getBtnByAuth('setSmartWristState')"
                            :title="'确定'+['启用','禁用'][inoutwarn.status]+'吗?'"
                            @confirm="warnsetState(inoutwarn.id,inoutwarn.status)"
                            >
                            <a-button >{{['启用','禁用'][inoutwarn.status]}}</a-button>
                        </a-popconfirm>
                    </a-col>
                </a-row>
                <a-row class="pb16 pt24">
                    <a-col :span="colOne">
                        <div class="title-text pb8">设备非法出场告警</div>
                        设备离开了周边有效区域超过设时未返场内进行告警
                    </a-col>
                    <a-col :span="colTwo" class="text-primary pt32">
                        时间：{{inoutwarn.departureIntervalTime || '--'}}分钟
                    </a-col>
                    <a-col v-if="flag" :span="colThree" class="pt16">
                        <a-popconfirm
                            v-if="getBtnByAuth('setSmartWristState')"
                            :title="'确定'+['启用','禁用'][inoutwarn.status]+'吗?'"
                            @confirm="warnsetState(inoutwarn.id,inoutwarn.status)"
                            >
                            <a-button >{{['启用','禁用'][inoutwarn.status]}}</a-button>
                        </a-popconfirm>
                        <a-button @click="openIllegal(inoutwarn.id)" v-if="getBtnByAuth('setSmartWristEdit')">编辑</a-button>
                    </a-col>
                </a-row>
                <a-row class="pb16 pt24">
                    <a-col :span="colOne">
                        <div class="title-text pb8">超时未入场告警</div>
                        设备绑定后，超过设定时间未刷卡进场进行告警
                    </a-col>
                    <a-col :span="colTwo" class="text-primary pt32">
                        时间：{{noInwarn.departureIntervalTime || '--'}}分钟
                    </a-col>
                    <a-col v-if="flag" :span="colThree" class="pt16">
                        <a-popconfirm
                            v-if="getBtnByAuth('setSmartWristState')"
                            :title="'确定'+['启用','禁用'][noInwarn.status]+'吗?'"
                            @confirm="warnsetState(noInwarn.id,noInwarn.status)"
                            >
                            <a-button >{{['启用','禁用'][noInwarn.status]}}</a-button>
                        </a-popconfirm>
                        <a-button @click="openNoInwarn(noInwarn.id)" v-if="getBtnByAuth('setSmartWristEdit')">编辑</a-button>
                    </a-col>
                </a-row>
            </a-card>
            <div class="mt24"></div>
            <a-card title="离场配置">
                <a-row class="pb16 pt24">
                    <a-col :span="colOne">
                        <div class="title-text pb8">离场次数设置</div>
                        可设置闸机的开门次数
                    </a-col>
                    <a-col :span="colTwo" class="text-primary pt32">
                        次数：{{leaveSet.departureIntervalGap || '--'}}次
                    </a-col>
                    <a-col v-if="flag" :span="colThree" class="pt16">
                        <a-popconfirm
                            v-if="getBtnByAuth('setSmartWristState')"
                            :title="'确定'+['启用','禁用'][leaveSet.status]+'吗?'"
                            @confirm="warnsetState(leaveSet.id,leaveSet.status)"
                            >
                            <a-button >{{['启用','禁用'][leaveSet.status]}}</a-button>
                        </a-popconfirm>
                        <a-button @click="openUpdateDepartureIntervalGap(leaveSet.id)" v-if="getBtnByAuth('setSmartWristEdit')">编辑</a-button>
                    </a-col>
                </a-row>
                <a-row class="pb16 pt24">
                    <a-col :span="colOne">
                        <div class="title-text pb8">离场时间设置</div>
                        用户在设置的离场时间内刷卡即可开门
                    </a-col>
                    <a-col :span="colTwo" class="text-primary pt32">
                        时间：{{leaveSet.departureIntervalTime || '--'}}分钟
                    </a-col>
                    <a-col v-if="flag" :span="colThree" class="pt16">
                        <a-popconfirm
                            v-if="getBtnByAuth('setSmartWristState')"
                            :title="'确定'+['启用','禁用'][leaveSet.status]+'吗?'"
                            @confirm="warnsetState(leaveSet.id,leaveSet.status)"
                            >
                            <a-button >{{['启用','禁用'][leaveSet.status]}}</a-button>
                        </a-popconfirm>
                        <a-button @click="openUpdateDepartureIntervalTime(leaveSet.id)" v-if="getBtnByAuth('setSmartWristEdit')">编辑</a-button>
                    </a-col>
                </a-row>
            </a-card>
            <a-modal @ok="updateChild" :confirmLoading="confirmLoading" :maskClosable="false" title="儿童出场告警" v-model="visibleChild" centered>
                <a-form :form="form1">
                    <a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                        <span slot="label">
                            离场间隔时间&nbsp;
                            <a-tooltip title="儿童出场，且任一大人≤自定义时间未出场进行告警">
                                <a-icon type="question-circle-o" />
                            </a-tooltip>
                        </span>
                        <a-input-number style="width:200px" v-decorator="['departureIntervalTime',{initialValue: childwarns.departureIntervalTime || undefined}]" />
                        <span class="ml8">分钟</span>
                    </a-form-item>

                    <a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                        <span slot="label">
                            离场间隔距离&nbsp;
                            <a-tooltip title="儿童出场，且与所有大人≥自定义距离进行告警">
                                <a-icon type="question-circle-o" />
                            </a-tooltip>
                        </span>
                        <a-input-number style="width:200px" v-decorator="['departureIntervalGap',{initialValue: childwarns.departureIntervalGap || undefined}]" />
                        <span class="ml8">米</span>
                    </a-form-item>

                    <a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                        <span slot="label">
                            用户通知&nbsp;
                        </span>
                        <a-checkbox v-model="smsEnable" >
                            短信通知
                        </a-checkbox>
                        <a-checkbox v-model="voiceEnable" >
                            语音通知
                        </a-checkbox>
                    </a-form-item>
                    <div class="ml40">
                        <span class="text-fail">*</span>以上条件满足任一进行告警
                    </div>
                </a-form>
            </a-modal>
            <a-modal @ok="updateIllegal" :confirmLoading="confirmLoading" :maskClosable="false" title="设备非法出场告警" v-model="visibleIllegal" centered>
                <a-form :form="form2">
                    <a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                        <span slot="label">
                            离场间隔时间&nbsp;
                            <a-tooltip title="设备离开周边有效区域，且≥自定义时间未返场进行告警">
                                <a-icon type="question-circle-o" />
                            </a-tooltip>
                        </span>
                        <a-input-number style="width:200px" v-decorator="['departureIntervalTime',{initialValue: inoutwarn.departureIntervalTime || undefined}]" />
                        <span class="ml8">分钟</span>
                    </a-form-item>
                </a-form>
            </a-modal>
            <a-modal @ok="updateNoInwarn" :confirmLoading="confirmLoading" :maskClosable="false" title="超时未入场告警" v-model="visibleNoInwarn" centered>
                <a-form :form="form3">
                    <a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                        <span slot="label">
                            设置间隔时间&nbsp;
                            <a-tooltip title="设备绑定后，≥定义时间未刷卡进场进行告警">
                                <a-icon type="question-circle-o" />
                            </a-tooltip>
                        </span>
                        <a-input-number style="width:200px" v-decorator="['departureIntervalTime',{initialValue: noInwarn.departureIntervalTime || undefined}]" />
                        <span class="ml8">分钟</span>
                    </a-form-item>
                </a-form>
            </a-modal>
            <a-modal @ok="updateDepartureIntervalGap" :confirmLoading="confirmLoading" :maskClosable="false" title="离场次数设置" v-model="visibleUpdateDepartureIntervalGap" centered>
                <a-form :form="form4">
                    <a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                        <span slot="label">
                            离场次数&nbsp;
                            <a-tooltip title="设备离场后，离场次数>可离场次数，出场后将不能再次入场">
                                <a-icon type="question-circle-o" />
                            </a-tooltip>
                        </span>
                        <a-input-number style="width:200px" v-decorator="['departureIntervalGap',{initialValue: leaveSet.departureIntervalGap || undefined}]" />
                        <span class="ml8">次</span>
                    </a-form-item>
                </a-form>
            </a-modal>
            <a-modal @ok="updateDepartureIntervalTime" :confirmLoading="confirmLoading" :maskClosable="false" title="离场时间设置" v-model="visibleUpdateDepartureIntervalTime" centered>
                <a-form :form="form5">
                    <a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                        <span slot="label">
                            离场间隔时间&nbsp;
                            <a-tooltip title="设备离场后，离场时间>可离场时间，将不能再次入场">
                                <a-icon type="question-circle-o" />
                            </a-tooltip>
                        </span>
                        <a-input-number style="width:200px" v-decorator="['departureIntervalTime',{initialValue: leaveSet.departureIntervalTime || undefined}]" />
                        <span class="ml8">分钟</span>
                    </a-form-item>
                </a-form>
            </a-modal>
        </div>
    </content-view>
    <router-view v-else></router-view>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
export default {
    name: "setSmartWrist",
    components: {},
    props: {},
    data() {
        return {
            confirmLoading: false,
            visibleChild: false,
            visibleIllegal: false,
            visibleNoInwarn: false,
            visibleUpdateDepartureIntervalGap: false,
            visibleUpdateDepartureIntervalTime: false,
            colOne: 10,
            colTwo: 10,
            colThree: 4,
            childwarns: {},
            inoutwarn: {},
            noInwarn: {},
            leaveSet: {},
            childId: undefined,
            illegalId: undefined,
            noInwarnId: undefined,
            leaveSetId: undefined,
            smsEnable: false,
            voiceEnable: false,
            flag: false
        };
    },
    computed: {
        ...mapGetters(["shopId"])
    },
    beforeCreate() {
        this.form1 = this.$form.createForm(this);
        this.form2 = this.$form.createForm(this);
        this.form3= this.$form.createForm(this);
        this.form4= this.$form.createForm(this);
        this.form5= this.$form.createForm(this);
    },
    created() {},
    mounted() {
        this.getList()
    },
    methods: {
        getList() {
            if(!this.shopId) return
            this.$api.wrist.warnsetList({
                body: {
                    pageNum: 1,
                    pageSize: 999,
                    shopId: this.shopId
                }
            }).then(res => {
                if(res.childwarns.length === 0) {
                    this.$message.warning('请先联系管理员，进行初始化告警设置')
                }
                this.childwarns = res.childwarns[0];
                this.smsEnable = res.childwarns[0].smsEnable === 1;
                this.voiceEnable = res.childwarns[0].voiceEnable === 1;

                this.inoutwarn = res.inoutwarn[0];
                this.noInwarn = res.noInwarn[0];
                this.leaveSet = res.leaveSet[0];
                this.flag = true;
            })
        },
        openChild(id) {
            this.visibleChild = true;
            this.childId = id;
            this.smsEnable = this.childwarns.smsEnable === 1;
            this.voiceEnable = this.childwarns.voiceEnable === 1;
            this.form1.resetFields();
        },
        openIllegal(id) {
            this.visibleIllegal = true;
            this.illegalId = id;
            this.form2.resetFields();
        },
        openNoInwarn(id) {
            this.visibleNoInwarn = true;
            this.noInwarnId = id;
            this.form3.resetFields();
        },
        updateChild() {
            this.form1.validateFields((err,values) => {
                if(!err) {
                    values.id = this.childId;
                    values.type = 0;
                    values.departureIntervalTime = values.departureIntervalTime || 0;
                    values.departureIntervalGap = values.departureIntervalGap || 0;
                    values.smsEnable = this.smsEnable ? 1 : 2;
                    values.voiceEnable = this.voiceEnable ? 1: 2;
                    this.$api.wrist.warnsetEdit({
                        body: values
                    }).then(res => {
                        this.$message.success('操作成功')
                        this.visibleChild = false;
                        this.getList()
                    })
                }
            })
        },
        updateIllegal() {
            this.form2.validateFields((err,values) => {
                if(!err) {
                    values.id = this.illegalId;
                    values.type = 1;
                    values.departureIntervalTime = values.departureIntervalTime || 0;
                    this.$api.wrist.warnsetEdit({
                        body: values
                    }).then(res => {
                        this.$message.success('操作成功')
                        this.visibleIllegal = false;
                        this.getList()
                    })
                }
            })
        },
        updateNoInwarn() {
            this.form3.validateFields((err,values) => {
                if(!err) {
                    values.id = this.noInwarnId;
                    values.type = 2;
                    values.departureIntervalTime = values.departureIntervalTime || 0;
                    this.$api.wrist.warnsetEdit({
                        body: values
                    }).then(res => {
                        this.$message.success('操作成功')
                        this.visibleNoInwarn = false;
                        this.getList()
                    })
                }
            })
        },
        warnsetState(id,status) {
            this.$api.wrist.warnsetState({
                params: {
                    id: id,
                    status: status ? 0 : 1
                }
            }).then(res => {
                this.$message.success('操作成功')
                this.getList()
            })
        },
        openUpdateDepartureIntervalGap(id) {
            this.visibleUpdateDepartureIntervalGap = true;
            this.leaveSetId = id;
            this.form4.resetFields();
        },
        openUpdateDepartureIntervalTime(id) {
            this.visibleUpdateDepartureIntervalTime = true;
            this.leaveSetId = id;
            this.form5.resetFields();
        },
        updateDepartureIntervalGap() {
            this.form4.validateFields((err,values) => {
                if(err) {
                    return false;
                }
                values.id = this.leaveSetId;
                values.type = 3;
                values.departureIntervalGap = values.departureIntervalGap || 0;
                this.confirmLoading = true;
                this.$api.wrist.warnsetEdit({
                    body: values
                }).then(res => {
                    this.confirmLoading = false;
                    this.$message.success('操作成功');
                    this.visibleUpdateDepartureIntervalGap = false;
                    this.getList();
                })
            })
        },
        updateDepartureIntervalTime() {
            this.form5.validateFields((err,values) => {
                if(err) {
                    return false;
                }
                values.id = this.leaveSetId;
                values.type = 3;
                values.departureIntervalTime = values.departureIntervalTime || 0;
                this.confirmLoading = true;
                this.$api.wrist.warnsetEdit({
                    body: values
                }).then(res => {
                    this.confirmLoading = false;
                    this.$message.success('操作成功');
                    this.visibleUpdateDepartureIntervalTime = false;
                    this.getList();
                })
            })
        },
    },
    watch: {
        shopId() {
            this.getList()
        }
    }
}
</script>
<style lang="scss">
.integral-set {
    .line-bodder {
        border-bottom: 1px solid #ddd;
    }
    .title-text {
        @include pxAndLh(16);
        color: $text-color-black-85;
        font-weight: bold;
    }
}
</style>
